import { Stack, Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import questionsService from '../../services/questionsService'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { IBackendAnswer } from '../../store/reports/types'
import answersParser from '../../utils/AnswersParser'

interface IFormVictimAnswerHandler {
  victim: any
  victimIndex: number,
  question: any
}

const FormVictimAnswerHandler: FC<IFormVictimAnswerHandler> = ({ victim, victimIndex, question }) => {
  const [victimAnswers, setVictimAnswers] = useState<IBackendAnswer[]>([])
  const report = useSelector(reportsSelectors.selectedReport)

  const getVictimAnswers = async (victimId: number) => {
    const { data } = await questionsService.getVictimAnswers(victimId)
    if (data?.length > 0) {
      setVictimAnswers(data)
    }
  }
  useEffect(() => {
    getVictimAnswers(victim?.id)
  }, [])

  const valueRender = (value: string | number) => (value ? value : '-')
  if (question.type == 'FORM_RECIPIENT') {
    return (
      <>
        <Stack key={victim.id} className='t-form-section t-victim'>
          <Typography variant='bodyBold'>Victim {victimIndex + 1}</Typography>
          <Stack>
            <Typography variant='labelBold'>Name</Typography>
            <Typography variant='bodyRegular'>{valueRender(victim?.full_name)}</Typography>
          </Stack>
          <Stack>
            <Typography variant='labelBold'>Title</Typography>
            <Typography variant='bodyRegular'>{valueRender(victim?.title)}</Typography>
          </Stack>
          <Stack>
            <Typography variant='labelBold'>Work Location</Typography>
            <Typography variant='bodyRegular'>{valueRender(victim?.work_location)}</Typography>
          </Stack>
          <Stack>
            <Typography variant='labelBold'>Relationship to Sender</Typography>
            <Typography variant='bodyRegular'>{valueRender(victim?.relationship_to_sender)}</Typography>
          </Stack>
          <Stack>
            <Typography variant='labelBold'>Number of Communications Received</Typography>
            <Typography variant='bodyRegular'>{valueRender(victim?.number_of_communications)}</Typography>
          </Stack>
          {/* <Stack>
            <Typography variant='labelBold'>Work Site</Typography>
            <Typography variant='bodyRegular'>{valueRender(report?.workplace?.work_site)}</Typography>
          </Stack>
          <Stack>
            <Typography variant='labelBold'>Work City</Typography>
            <Typography variant='bodyRegular'>{valueRender(report?.workplace?.work_city)}</Typography>
          </Stack>
          <Stack>
            <Typography variant='labelBold'>Work Country</Typography>
            <Typography variant='bodyRegular'>
              {valueRender(report?.workplace?.work_country)}
            </Typography>
          </Stack> */}
          <Stack className={'t-victim-answers'}>
            {victimAnswers?.length > 0 && victimAnswers.map(answer => answersParser(answer, true))}
          </Stack>
        </Stack>
      </>
    )
  }
  return (
    <>
      <Stack key={victim.id} className='t-form-section t-victim'>
        <Typography variant='bodyBold'>Victim {victimIndex + 1}</Typography>
        <Stack>
          <Typography variant='labelBold'>Subject Name</Typography>
          <Typography variant='bodyRegular'>{valueRender(victim?.full_name)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Phone Number</Typography>
          <Typography variant='bodyRegular'>{valueRender(victim?.phone_number)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Description</Typography>
          <Typography variant='bodyRegular'>{valueRender(victim?.description)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Work Site</Typography>
          <Typography variant='bodyRegular'>{valueRender(report?.workplace?.work_site)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Work City</Typography>
          <Typography variant='bodyRegular'>{valueRender(report?.workplace?.work_city)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Work Country</Typography>
          <Typography variant='bodyRegular'>
            {valueRender(report?.workplace?.work_country)}
          </Typography>
        </Stack>
        <Stack className={'t-victim-answers'}>
          {victimAnswers?.length > 0 && victimAnswers.map(answer => answersParser(answer, true))}
        </Stack>
      </Stack>
    </>
  )
}

export default FormVictimAnswerHandler
